import { Dialog, DialogTitle, DialogCloseButton } from './dialog';
import { ProviderReferralContent } from './provider-referral-content';
import { Text } from './text';

interface ProviderReferralDialogProps {
  open: boolean;
  onClose: () => void;
  /** When present, sharing options (Copy Link, Message, Suggested Message) are hidden. */
  programId?: string;
}

export function ProviderReferralDialog({ open, onClose, programId }: ProviderReferralDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} size="lg">
      <div className="tw:flex tw:flex-col">
        {/* Header */}
        <div className="tw:flex tw:items-start tw:justify-between tw:gap-4">
          <div>
            <DialogTitle>Locums Without the Agency. Finally.</DialogTitle>
            <Text className="tw:mt-2 tw:text-sm tw:text-zinc-600">
              Help your colleagues keep more of what they earn.
            </Text>
          </div>
          <DialogCloseButton onClick={onClose} className="tw:shrink-0" />
        </div>

        <ProviderReferralContent active={open} programId={programId} />
      </div>
    </Dialog>
  );
}
